import api from "../services/api";

// ✅ get photos by category
export const getPhotosByCategory = async (categoryId) => {
  const res = await api.get(`${"/Photos"}/category/${categoryId}`);
  return res.data;
};

// ✅ upload multiple photos
export const uploadPhotos = async (formData) => {
  const res = await api.post(`${"/Photos"}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
